import React from "react";
import { Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Layout from "../shared/Layout";
import LayoutFullWidth from "../shared/Layout/LayoutFullWidth";
import Remnants from "../Remnants";
import RemnantsSectionNav from "../Remnants/RemnantsSectionNav";
import WarehouseOverview from "../Remnants/WarehouseOverview";
import MpSyncDashboard from "../Remnants/v2/MpSyncDashboard";
import RemnantsManagePage from "../RemnantsManage";
import FbsOrdersAnalytics from "../FbsOrdersAnalytics";

/**
 * /remnants — обзор по физскладам
 * /remnants/manage — управление остатками FBS
 * /remnants/fbs-orders — аналитика заказов FBS
 * /remnants/sync-dashboard — дашборд WB + Ozon
 * /remnants/legacy — старая таблица
 */
const RemnantsPage = () => {
  const { pathname } = useLocation();
  const isLegacy = pathname === "/remnants/legacy";
  const isManage = pathname === "/remnants/manage";
  const isFbsOrders = pathname === "/remnants/fbs-orders";
  const isDashboard = pathname.includes("/sync-dashboard");
  const isOverview = pathname === "/remnants";

  const body = (
    <Container
      fluid={isManage || isDashboard || isOverview || isFbsOrders || undefined}
    >
      <RemnantsSectionNav />
      <Row>
        {isManage ? (
          <RemnantsManagePage />
        ) : isFbsOrders ? (
          <FbsOrdersAnalytics />
        ) : isDashboard ? (
          <MpSyncDashboard />
        ) : isLegacy ? (
          <Remnants />
        ) : (
          <WarehouseOverview />
        )}
      </Row>
    </Container>
  );

  if (isManage) {
    return (
      <LayoutFullWidth>
        <div
          style={{
            marginLeft: -28,
            marginRight: -28,
            width: "calc(100% + 56px)",
            paddingLeft: 12,
            paddingRight: 12,
            boxSizing: "border-box",
          }}
        >
          {body}
        </div>
      </LayoutFullWidth>
    );
  }

  return <Layout>{body}</Layout>;
};

export default RemnantsPage;
